module.exports = __webpack_public_path__ + "static/media/hudy.bd029341.png";